import EcgLoader from './EcgLoader'

export default EcgLoader
